import React, { useState } from "react";
import { EmailTemplateDetailsDrawerContent } from "./contents/EmailTemplateDetailsDrawerContent";
import { RouteSearchParam } from "../../../../routes/RoutesHelper";
import { useSearchParams } from "react-router-dom";
import { UnexpectedErrorDialog } from "../../../../components/dialogs/UnexpectedErrorDialog";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { useEmailTemplateDetailsStore } from "../../stores/Hooks";
import { NonDismissibleDrawer } from "../../../../components/drawer/NonDismissibleDrawer";

interface EmailTemplateDetailsDrawerProps {
  open: boolean;
  onClose: VoidFunction;
  setOpenConfirmDeleteEmailTemplateDialog: React.Dispatch<
    React.SetStateAction<boolean>
  >;
}

const EMAIL_TEMPLATE_DETAILS_DRAWER_WIDTH = "1024px";

export const EmailTemplateDetailsDrawer: React.FC<EmailTemplateDetailsDrawerProps> =
  observer(({ open, onClose, setOpenConfirmDeleteEmailTemplateDialog }) => {
    const [openUnexpectedErrorDialog, setOpenUnexpectedErrorDialog] =
      useState(false);
    const [, setSearchParams] = useSearchParams();
    const { t } = useTranslation();

    const emailTemplateDetailsStore = useEmailTemplateDetailsStore();

    const handleDrawerClose = (): void => {
      onClose();
      emailTemplateDetailsStore.resetStore();
      setSearchParams((prev) => {
        prev.delete(RouteSearchParam.TemplateId);
        prev.delete(RouteSearchParam.Mode);
        return prev;
      });
    };

    return (
      <>
        <NonDismissibleDrawer
          open={open}
          anchor="right"
          onClose={handleDrawerClose}
          slotProps={{
            paper: {
              sx: {
                width: "100%",
                maxWidth: EMAIL_TEMPLATE_DETAILS_DRAWER_WIDTH,
              },
            },
          }}
        >
          <EmailTemplateDetailsDrawerContent
            handleDrawerClose={handleDrawerClose}
            setOpenUnexpectedErrorDialog={setOpenUnexpectedErrorDialog}
            setOpenConfirmDeleteEmailTemplateDialog={
              setOpenConfirmDeleteEmailTemplateDialog
            }
          />
        </NonDismissibleDrawer>

        {openUnexpectedErrorDialog && (
          <UnexpectedErrorDialog
            message={t("emailTemplates.getDetailsUnexpectedErrorMessage")}
            onClickDone={() => setOpenUnexpectedErrorDialog(false)}
          />
        )}
      </>
    );
  });
